export default __webpack_public_path__ + "static/media/24x7.c266ec0d.svg";